import React, { useEffect, useState } from "react";
import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import Loading from "../../../../components/common/Loading";

// Fix default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export const Location_Details = ({ program_id }) => {
  const latitude = 28.545955;
  const longitude = 77.18614;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [])

  return (
    <>
      {loading
        ? <div className="py-5" style={{ height: "20vh" }}><Loading /></div>
        : <>
          <div style={{ height: "60vh", width: "100%" }}>
            <MapContainer
              center={[latitude, longitude]}
              zoom={16}
              style={{ height: "100%", width: "100%" }}
              scrollWheelZoom={false}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[latitude, longitude]}>
                <Popup>
                  IHFC Campus <br /> IIT Delhi
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </>}
    </>
  );
};






// import React from "react";
// import GoogleMapReact from 'google-map-react';

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

// export default function Location_Details(){
//   const defaultProps = {
//     center: {
//       lat: 28.545955,
//       lng: 77.18614
//     },
//     zoom: 12
//   };

//   return (
//     // Important! Always set the container height explicitly
//     <div style={{ height: '60vh', width: '100%' }}>
//       <GoogleMapReact
//         bootstrapURLKeys={{ key: "" }}
//         defaultCenter={defaultProps.center}
//         defaultZoom={defaultProps.zoom}
//       >
//         <AnyReactComponent
//           lat={59.955413}
//           lng={30.337844}
//           text="My Marker"
//         />
//       </GoogleMapReact>
//     </div>
//   );
// }